<template>
  <div class="wrap">
    <div class="topWrap"></div>
    <div class="centerWrap">
          <div class="d-flex">
            <div class="vote-tag-title titleWrap">数字化学习未来实验室</div>
          </div>
          <div class="vote-body px-5 pt-6">学习力调查</div>
          <div class="vote-en-body px-5 pt-1">Learning Power Research</div>
          <div class="d-flex flex-column justify-center align-center">
            <div ref="main" id="main" style="width: 80%; height: 500px"></div>
            <v-btn class="mt-6" color="success" @click="toQuestion">参与调查</v-btn>
          </div>
          <div class="footerText">
             <P><span>元学</span>  <span></span></P>
          </div>
    </div>
    <div class="bottomWrap"></div>
  </div>
</template>
<script>
import * as echarts from 'echarts';
// import { queryEvaluation } from '../../../api/Indicatorevaluation.js';
export default {
  data() {
    return {
      dom: {},
    };
  },
  created() {
    console.log('on create :>> ');
    this.$nextTick(() => {
      this.initEcharts();
    });
    // this.QueryEvaluation()
  },
  methods: {
    // QueryEvaluation(){
    //   queryEvaluation().then(res=>{
    //    console.log(res,'-------------------')
    // })
    // },
    initEcharts() {
      console.log('this.$refs.main :>> ', this.$refs.main);
      let myChart = echarts.init(this.$refs.main);
      window.onresize = function () {
        myChart.resize();
      };
      myChart.off('click'); //防止多次触发，在给ehcart绑定事件时，要先写上此代码。
      myChart.on('click', params => {
        //在此处编写内容
        console.log(params);
      });
      let option;

      let serveData = [
        { value: 1048, name: '记忆能力', color: 'rgb(61, 119, 54)' },
        { value: 735, name: '理解能力', color: 'rgb(154, 197, 74)' },
        { value: 580, name: '创新能力', color: 'rgb(174, 37, 27)' },
      ];

      option = {
        legend: {
          orient: 'vertical', //vertical horizontal
          // top: 16,
          // icon: "circle",
          selectedMode: false,
          itemWidth: 6,
          itemHeight: 6,
          itemGap: 6,
          borderRadius: 6,
          data: serveData ? serveData.map(item => item.name) : [],
          bottom: 'bottom',
        },

        tooltip: {
          trigger: 'item',
        },

        series: [
          {
            color: serveData ? serveData.map(item => item.color) : [],
            name: '学习力认知',
            type: 'pie',
            radius: ['40%', '70%'],
            avoidLabelOverlap: false,
            label: {
              //echarts饼图内部显示百分比设置
              show: true,
              position: 'inside', //outside 外部显示  inside 内部显示
              // formatter: `{d}%`,
              formatter: function (data) {
                return data.percent ? data.percent.toFixed(0) + '%' : 0;
              },
              color: '#ffffff', //颜色
              fontSize: 12, //字体大小
            },

            labelLine: {
              show: false,
            },
            data: serveData,
          },
        ],
      };
      option && myChart.setOption(option);
    },
    toQuestion() {
      this.$router.push({
        path: '/vote/question',
      });
    },
  },
};
</script>
<style>
.vote-tag-title {
  background-color: #478845;
  color: #fff;
  font-size: 1rem;
  font-weight: bold;
  letter-spacing: 0.2em;
}

.titleWrap {
  padding: 6px 40px 6px 6px !important;
}

.vote-body {
  color: #478845;
  font-size: 2rem;
  font-weight: bold;
  letter-spacing: 0.1em;
}

.vote-en-body {
  color: #478845;
  font-size: 0.8rem;
  font-weight: bold;
  letter-spacing: 0.1em;
}

.topWrap {
  height: 8%;
  width: 100%;
  border-bottom: 1px dashed gray;
}
.centerWrap{
  position:relative;
  height: 84%;
}
.bottomWrap {
  height: 8%;
  width: 100%;
  border-top: 1px dashed gray;
}

.wrap{
  position: fixed;
  width: 100%;
  height: 100%;
}
.footerText{
  position: absolute;
  bottom: 0px;
  color: #478845;
  width: 100%;
  /* font-size: 0.8rem; */
  /* font-weight: bold; */
  /* letter-spacing: 0.1em; */
  

}
.footerText p{
  
  margin: 0px;
  height: 30px;
  line-height: 30px;
  font-weight: bold;
  text-align: right;
}
.footerText p span{
 display: inline-block;
}
.footerText p span:nth-child(2){
  margin-right: 10px;
}
</style>
